module.exports = __webpack_public_path__ + "img/hospitium-15.ab076eee.jpg";